export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const MEDIA_BUNDLE_PREFIX = "@@MEDIA_BUNDLE::";
export const MEDIA_BUNDLE_SUFFIX = "@@";
export const CHAT_LINK_PREFIX    = "@@CHAT_LINK::";
export const CHAT_LINK_SUFFIX    = "@@";

// 전역 ref: Message 컴포넌트에서 #채널명, @닉네임 파싱 시 사용
export const channelsRef    = { current: [] };
export const onlineUsersRef = { current: [] };
// 메시지를 밀어 답장한 손짓이면 true — 같은 손짓에 화면 서랍(접속자 목록)이 열리지 않게 ChatPage 가 확인하고 지운다
export const gestureState = { replySwipe: false };
export const DOWNLOAD_SHARE_PREFIX = "@@DOWNLOAD_SHARE::";
export const DOWNLOAD_SHARE_SUFFIX = "@@";
// 마우스 호버가 없는 터치 기기 (길게 누르기 메뉴·스와이프 답장 사용)
export const isTouchDevice = typeof window !== 'undefined' && !!window.matchMedia?.('(hover: none) and (pointer: coarse)').matches;
